var info = {
  title: 'MatrixGold | Join our Live Session Webinar',
  video: 'https://gemvision.com/sharedMedia/mg_landing.mp4',
  poster: 'https://meteor.stullercloud.com/das/116998425',
  background: 'https://meteor.stullercloud.com/das/116998419',
  host: 'https://meteor.stullercloud.com/das/116998429',
  hostDescription: 'Beau Vallot, Central Territory sales rep.',
  logo: 'https://gemvision.com/Images/MatrixGold/MatrixGold%20Light%20Registered.svg',
  description1:
    'Register to attend a 60-minute MatrixGold webinar to learn how our software can help boost your custom business. As a special thank you for your participation and to help you get started, we’re offering a 5% discount on the purchase of your first license.',
  description2:
    'MatrixGold was designed to help make you a more efficient designer by allowing you to create simple and complex models from scratch, apply edits without rebuilding the whole model, and generate as many variations as you want from a single model with just a few clicks. It features an upgraded CAD engine, improved speed and responsiveness, and new content organization.',
  buttonColor: '#b4975a',
  titleBackgroundColor: '#000000'
}

export default info
